import Vue from 'vue'
import Vuex from 'vuex'
import Req from '../req'
import md5 from 'js-md5'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		loginUrl: "https://open.weixin.qq.com/connect/qrconnect?appid=wxa64ad1d6cb625050&redirect_uri=http://www.ionewu.com/wx_login.html?url=" + encodeURIComponent(window.location.href.split("?")[0]) + "&response_type=code&scope=snsapi_login&state=#wechat_redirect",
		user: {
			uid: "",
			suid: "",
			tuid: "",
			openid: "",
			headimg: "",
			nickname: "",
			leftTime: 0
		},
		app: {
			appid: "wx653b5449fa8d8668"
		},
		router: {
			buid: "",
			appid: "",
			chanid: "",
			type: "",
			refuid: ""
		},
		sys: {
			pid: "",
			cid: "",
			did: "",
			cname: ""
		},
		host: {
			router: "http://10.101.202.1:8283",
			api: process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging' || true == true ? "https://c.ionewu.com" : "http://120.79.85.152",
			kdtsApi: process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging' || true == true ? "https://kdts.ionewu.com" : "https://kdts-test.ionewu.com",
			static: "https://d.ionewu.com",
			pay: process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging' ? "https://tan.ionewu.com" : "https://tan.ionewu.com",
			authHtml: process.env.NODE_ENV === 'production' ? "http://tan.ionewu.com/kd/wxauth.html" : ("http://tan.ionewu.com/" + process.env.NODE_ENV + "/wxauth.html"),
			tanApi: process.env.NODE_ENV === 'test' ? "http://localhost:9011/kuandai" : "https://tan.ionewu.com/api/kuandai",
			statApi: process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging' || true == true ? "https://stat.ionewu.com" : "https://stat.ionewu.com",
		},
		isShowLogin: false,
		isShowGuide: false,
		isShowDesc: true,
		isLogin: false,
		isSupportUp: false,
		isCheckSupportUp: false,
		isSupportDown: false,
		isCheckSupportDown: false,
		isGetUserLeftUp: false,
		isGetUserLeftDown: false,
		isPayNow: false, // 是否刚支付
		isPayUp: false,
		isPayDown: false,
		isShowPay: false,
		isUpTry: false,
		isDownTry: false,
		isUpTryEnd: false,
		isDownTryEnd: false,
		isShowGuoqing: false,
		isShowDownCheckAnimation: false,
		isShowUpCheckAnimation: false,
		upTryTimestamp: 0,
		downTryTimestamp: 0,
		upTryLeft: 0,
		downTryLeft: 0,
		speedUpStatus: 0,
		speedUpErrno: 0,
		speedDownStatus: 0,
		speedDownErrno: 0,
		queryUpCode: 0,
		queryDownCode: 0,
		payType: 'up',
		isShowLoading: false,
		isShowLoadingImg: true,
		isShowQrcode: false,
		upPay: {
			left: 0,
			leftDay: 10
		},
		nowUpSpeed: 0,
		toUpSpeed: 0,
		downPay: {
			left: 0,
			leftDay: 10
		},
		nowDownSpeed: 0,
		toDownSpeed: 0,
		goods: [],
		goodsUp: [],
		goodsDown: [],
		province: "", // 省份
		isp: "", // 运营商
		localAccount: "", //  当前宽带账号
		bindAccount: "", // 绑定宽带账号
		localUpAccount: "", //  当前宽带账号
		bindUpAccount: "", // 绑定宽带账号
		localDownAccount: "", //  当前宽带账号
		bindDownAccount: "", // 绑定宽带账号
		localPid: "", // 当前设备
		bindPid: "", // 绑定设备
		bindAddr: "" // 绑定IP
	},
	mutations: {},
	actions: {
		getPid: function (store, [sn, mac, cb]) {
			let data = {
				sn: sn,
				mac: mac,
				appid: store.state.router.appid
			}
			Req.dev.pid(data, cb);
		},
		getDevUser: function (store, [pid, cb]) {
			let ts = parseInt(new Date().getTime() / 1000);
			let data = {
				appid: store.state.router.appid,
				ts: ts
			}
			store.dispatch('getToken', [pid, function (err, tdata) {
				if (err && tdata.rtn != 0) {
					cb ? cb(err, null) : null;
				} else {
					let token = tdata.tk;
					data.tk = token;
					data.code = md5("appid:" + store.state.router.appid + ";token:" + token).toLocaleUpperCase();
					Req.dev.user(data, function (err, data) {
						if (!err && data.rtn === 0) {
							// test
							// data.uid = "210";

							store.state.user.uid = data.uid;
							store.state.user.tuid = data.uid;
							store.state.user.suid = "";
							if (data.suid) {
								store.state.user.uid = data.suid;
								store.state.user.tuid = data.uid;
								store.state.user.suid = data.suid;
							}

							localStorage.setItem("kd2-uid", data.uid)
							store.state.isLogin = true;
							store.dispatch('sendUserlog', ["login", ""]);
						}
						cb ? cb(err, data) : null;
					});
				}
			}]);
		},
		getToken: function (store, [pid, cb]) {
			let ts = parseInt(new Date().getTime() / 1000);
			let data = {
				appid: store.state.router.appid,
				pid: pid ? pid : store.state.localPid,
				ts: ts
			}
			Req.dev.login(data, cb);
		},
		sendUserlog: function (store, [type, msg, cb]) {
			let data = {
				uid: store.state.user.uid,
				openid: store.state.user.openid,
				pid: store.state.bindPid,
				appid: store.state.router.appid,
				chanid: store.state.router.chanid,
				refuid: store.state.router.refuid,
				type: type,
				msg: msg
			}
			Req.router.log.user(data, cb);
		},
		setPidInfo: function (store, [pid]) {
			if (pid.length > 6) {
				store.state.sys.cid = parseInt(pid.substr(-6, 2), 16);
				store.state.sys.did = parseInt(pid.substr(-4, 2), 16);
				switch (store.state.sys.cid) {
					case 101:
						store.state.sys.cname = "英莱NAS"
						break;
					case 104:
						store.state.sys.cname = "必联路由"
						break;
					case 106:
						store.state.sys.cname = "极路由"
						break;
					case 107:
						store.state.sys.cname = "群晖NAS"
						break;
					case 108:
						store.state.sys.cname = "铁威马NAS"
						break;
					case 109:
						store.state.sys.cname = "爱快路由"
						break;
					case 110:
						store.state.sys.cname = "群晖NAS"
						break;
					case 111:
						store.state.sys.cname = "华为路由"
						break;
					case 112:
						store.state.sys.cname = "磊科路由"
						break;
					default:
						break;
				}
			}
		},
		findLanDevice: function (store, [cb]) {
			let data = {
				uid: store.state.user.uid,
				openid: store.state.user.openid
			}
			if (store.state.user.suid) {
				delete data.uid;
				data.suid = store.state.user.suid
			}
			Req.router.server.lan.find(data, function (err, data) {
				cb ? cb(err, data) : null;
			});
		},
		getSpeedOpen: function (store, [type, cb]) {
			let reqData = {
				uid: store.state.user.uid,
				openid: store.state.user.openid,
				type: type,
				addr: store.state.bindAddr,
				pid: ""
			}
			if (store.state.user.suid) {
				delete reqData.uid;
				reqData.suid = store.state.user.suid
			}
			if (store.state.router.appid == "QH360V5SRT" || store.state.router.appid == "ToToLink") {
				reqData.pid = store.state.localPid;
			}
			if (!store.state.bindAccount) {
				reqData.addr = "";
			} else if (store.state.bindAccount == store.state.localAccount) {
				// 如果宽带账号相同，用当前IP提速
				reqData.addr = "";
			} else if (type == 1 && store.state.bindUpAccount == store.state.localUpAccount) {
				// 如果宽带账号相同，用当前IP提速
				reqData.addr = "";
			} else if (type == 2 && store.state.bindDownAccount == store.state.localDownAccount) {
				// 如果宽带账号相同，用当前IP提速
				reqData.addr = "";
			}
			Req.router.server.open(reqData, function (err, data) {

				if (type === 1) {
					store.dispatch('sendUserlog', ["open_up", JSON.stringify(reqData) + JSON.stringify(data)]);
				} else if (type === 2) {
					store.dispatch('sendUserlog', ["open_down", JSON.stringify(reqData) + JSON.stringify(data)]);
				}

				// 付费后默认提速成功
				if (store.state.isPayNow) {
					err = null;
					data = {
						code: 0
					};
				}

				if (!err) {
					// test
					// data = {
					// 	"code": 1,
					// 	"msg": "ok"
					// }
					if (data.code === 0) {
						if (type === 1) {
							store.state.speedUpStatus = 1;
							store.state.speedUpErrno = 0;
							if (!store.state.bindUpAccount) {
								store.state.bindUpAccount = store.state.localUpAccount;
							}
						} else if (type === 2) {
							store.state.speedDownStatus = 1;
							store.state.speedDownErrno = 0;
							if (!store.state.bindDownAccount) {
								store.state.bindDownAccount = store.state.localDownAccount;
							}
						}
						if (!store.state.bindAccount) {
							store.state.bindAccount = store.state.localAccount;
						}
					} else {
						if (type === 1) {
							store.state.speedUpStatus = 0;
							store.state.speedUpErrno = data.code;
						} else if (type === 2) {
							store.state.speedDownStatus = 0;
							store.state.speedDownErrno = data.code;
						}
					}
				}
				cb ? cb(err, data) : null;
			});
		},
		// 用当前IP提 弃用
		getSpeedOpenLocal: function (store, [type, cb]) {
			let data = {
				uid: store.state.user.uid + "",
				openid: store.state.user.openid,
				type: type
			}
			if (store.state.user.suid) {
				delete data.uid;
				data.suid = store.state.user.suid
			}
			Req.router.server.open(data, function (err, data) {
				if (type === 1) {
					store.dispatch('sendUserlog', ["open_up", JSON.stringify(data)]);
				} else if (type === 2) {
					store.dispatch('sendUserlog', ["open_down", JSON.stringify(data)]);
				}

				if (!err) {
					if (data.code === 0) {
						if (type === 1) {
							store.state.speedUpStatus = 1;
							store.state.speedUpErrno = 0;
							if (!store.state.bindUpAccount) {
								store.state.bindUpAccount = store.state.localUpAccount;
							}
						} else if (type === 2) {
							store.state.speedDownStatus = 1;
							store.state.speedDownErrno = 0;
							if (!store.state.bindDownAccount) {
								store.state.bindDownAccount = store.state.localDownAccount;
							}
						}
						if (!store.state.bindAccount) {
							store.state.bindAccount = store.state.localAccount;
						}
					}
				}
				cb ? cb(err, data) : null;
			});
		},
		getSpeedStatus: function (store, [type, cb]) {
			let data = {
				uid: store.state.user.uid + "",
				openid: store.state.user.openid,
				type: type
			}
			if (store.state.user.suid) {
				delete data.uid;
				data.suid = store.state.user.suid
			}
			if (store.state.router.appid == "QH360V5SRT" || store.state.router.appid == "ToToLink") {
				data.pid = store.state.localPid;
			}
			Req.router.server.status(data, function (err, data) {
				// test
				// if (type == 1) {
				// 	data = {
				// 		"code": 0,
				// 		"msg": "ok",
				// 		"data": {
				// 			"status": 0,
				// 			"tserrno": 0,
				// 			"basic_down": 0,
				// 			"basic_up": 0,
				// 			"target_down": 0,
				// 			"target_up": 0,
				// 			"account": "",
				// 			"addr": "",
				// 			"pid": "",
				// 			"isp": "",
				// 			"city": "",
				// 			"province": "",
				// 			"country": ""
				// 		}
				// 	};
				// } else {
				// 	data = {
				// 		"code": 0,
				// 		"msg": "ok",
				// 		"data": {
				// 			"status": 1,
				// 			"tserrno": 0,
				// 			"basic_down": 1024,
				// 			"basic_up": 1024,
				// 			"target_down": 10240,
				// 			"target_up": 10240,
				// 			"account": "",
				// 			"addr": "",
				// 			"pid": "",
				// 			"isp": "",
				// 			"city": "",
				// 			"province": "",
				// 			"country": ""
				// 		}
				// 	};
				// }
				// data = {
				// 	"code": 0,
				// 	"msg": "ok",
				// 	"data": {
				// 		"status": 0,
				// 		"tserrno": 0,
				// 		"basic_down": 204800,
				// 		"basic_up": 30720,
				// 		"target_down": 307200,
				// 		"target_up": 0,
				// 		"account": "",
				// 		"addr": "",
				// 		"pid": "",
				// 		"isp": "",
				// 		"city": "",
				// 		"province": "",
				// 		"country": ""
				// 	}
				// }
				if (!err && data.code == 0) {

					store.state.province = data.data.province ? data.data.province : store.state.province;
					store.state.isp = data.data.isp ? data.data.isp : store.state.isp;

					if (data.data.pid) {
						store.state.bindPid = data.data.pid;
						store.dispatch('setPidInfo', [store.state.bindPid]);
					}
					if (data.data.account) {
						store.state.bindAccount = data.data.account;
						if (data.data.addr) {
							store.state.bindAddr = data.data.addr;
						}
					}

					if (type === 1) {

						store.state.speedUpStatus = data.data.status;
						store.state.speedUpErrno = data.data.tserrno;

						if (data.data.account) {
							store.state.bindUpAccount = data.data.account;
						}

						if (data.data.account || store.state.speedDownStatus == 1) {
							store.state.isCheckSupportUp = true;

							store.state.nowUpSpeed = data.data.basic_up / 1024;
							store.state.toUpSpeed = data.data.target_up / 1024;

							if (data.data.target_up > data.data.basic_up) {
								store.state.isShowUpCheckAnimation = true;
								store.state.isSupportUp = true;
							}
						}

					} else if (type === 2) {

						store.state.speedDownStatus = data.data.status;
						store.state.speedDownErrno = data.data.tserrno;

						if (data.data.account) {
							store.state.bindDownAccount = data.data.account;
						}

						if (data.data.account || store.state.speedDownStatus == 1) {
							store.state.isCheckSupportDown = true;

							store.state.nowDownSpeed = data.data.basic_down / 1024;
							store.state.toDownSpeed = data.data.target_down / 1024;

							if (data.data.target_down > data.data.basic_down) {
								store.state.isShowDownCheckAnimation = true;
								store.state.isSupportDown = true;
							}
						}

					}

				}

				if (type === 1) {
					store.dispatch('sendUserlog', ["status_up", JSON.stringify(data)]);
					if (store.state.isSupportUp) {
						store.dispatch('sendUserlog', ["check_up_success", JSON.stringify(data)]);
					}
				} else {
					store.dispatch('sendUserlog', ["status_down", JSON.stringify(data)]);
					if (store.state.isSupportDown) {
						store.dispatch('sendUserlog', ["check_down_success", JSON.stringify(data)]);
					}
				}

				cb ? cb(err, data) : null;
			});
		},
		getTryInfo: function (store, [type, cb]) {
			let data = {
				uid: store.state.user.uid + "",
				openid: store.state.user.openid,
				type: type,
				pid: ""
			}
			if (store.state.user.suid) {
				delete data.uid;
				data.suid = store.state.user.suid
			}
			if (store.state.router.appid == "QH360V5SRT" || store.state.router.appid == "ToToLink") {
				data.pid = store.state.localPid;
			}
			Req.router.server.try.info(data, function (err, data) {
				// test
				// data.data.left = 60;

				if (type === 1) {
					store.dispatch('sendUserlog', ["check_try_up", JSON.stringify(data)]);
				} else if (type === 2) {
					store.dispatch('sendUserlog', ["check_try_down", JSON.stringify(data)]);
				}

				if (!err) {
					if (type === 1) {
						store.state.upTryLeft = data.data.left;
					} else if (type === 2) {
						store.state.downTryLeft = data.data.left;
					}
				}

				cb ? cb(err, data) : null;
			});
		},
		getTryOpen: function (store, [type, cb]) {
			let data = {
				uid: store.state.user.uid + "",
				openid: store.state.user.openid,
				type: type,
				pid: ""
			}
			if (store.state.user.suid) {
				delete data.uid;
				data.suid = store.state.user.suid
			}
			if (store.state.router.appid == "QH360V5SRT" || store.state.router.appid == "ToToLink") {
				data.pid = store.state.localPid;
			}
			Req.router.server.try.open(data, function (err, data) {
				if (data.code === 0) {
					if (type === 1) {
						store.state.isUpTry = true;
					} else if (type === 2) {
						store.state.isDownTry = true;
					}
				} else {
					if (type === 1) {
						store.state.isUpTry = false;
					} else if (type === 2) {
						store.state.isDownTry = false;
					}
				}
				if (type === 1) {
					store.dispatch('sendUserlog', ["open_try_up", JSON.stringify(data)]);
				} else if (type === 2) {
					store.dispatch('sendUserlog', ["open_try_down", JSON.stringify(data)]);
				}
				cb ? cb(err, data) : null;
			});
		},
		getLocalAccount: function (store, [cb]) {
			let data = {
				uid: store.state.user.uid + "",
				openid: store.state.user.openid,
				type: 2
			}
			if (store.state.user.suid) {
				delete data.uid;
				data.suid = store.state.user.suid
			}
			if (store.state.router.appid == "QH360V5SRT" || store.state.router.appid == "ToToLink") {
				data.pid = store.state.localPid;
			}
			Req.router.server.userInfo(data, function (err, data) {
				// test
				// data = {
				// 	"code": 0,
				// 	"msg": "ok",
				// 	"data": {
				// 		"left": 0,
				// 		"basic_down": 204800,
				// 		"basic_up": 30720,
				// 		"target_down": 307200,
				// 		"target_up": 0,
				// 		"account": "cq::02367864683",
				// 		"isp": "联通",
				// 		"city": "",
				// 		"province": "北京",
				// 		"country": "中国"
				// 	}
				// };

				// data = {
				// 	"code": 3505,
				// 	"msg": "V未查到目标速率",
				// 	"data": {
				// 		"left": 5628202,
				// 		"basic_down": 512000,
				// 		"basic_up": 51200,
				// 		"target_down": 0,
				// 		"target_up": 0,
				// 		"account": "DCDCD5EF8E7889E0642F5ABB4F902C12915002455D467D73",
				// 		"addr": "120.85.107.117:4100",
				// 		"isp": "联通",
				// 		"city": "",
				// 		"province": "广东",
				// 		"country": "中国"
				// 	}
				// }

				if (!err && data.data) {
					store.state.localAccount = data.data.account;
					store.state.localDownAccount = data.data.account;
					if (data.data.left > 0) {
						store.state.isPayDown = true;
						store.state.downPay.left = data.data.left;
					} else {
						store.state.isPayDown = false;
						store.state.downPay.left = 0;
					}
					store.state.isGetUserLeftDown = true;
				}
				if (store.state.localAccount) {
					cb ? cb(err, data) : null;
				} else {
					store.dispatch('getLocalAccountUp', [cb]);
				}
			});
		},
		getLocalAccountUp: function (store, [cb]) {
			let data = {
				uid: store.state.user.uid,
				openid: store.state.user.openid,
				type: 1
			}
			if (store.state.user.suid) {
				delete data.uid;
				data.suid = store.state.user.suid
			}
			if (store.state.router.appid == "QH360V5SRT" || store.state.router.appid == "ToToLink") {
				data.pid = store.state.localPid;
			}
			Req.router.server.userInfo(data, function (err, data) {
				if (!err && data.data) {
					store.state.localAccount = data.data.account;
					store.state.localUpAccount = data.data.account;
					if (data.data.left > 0) {
						store.state.isPayUp = true;
						store.state.upPay.left = data.data.left;
					} else {
						store.state.isPayUp = false;
						store.state.upPay.left = 0;
					}
					store.state.isGetUserLeftUp = true;
				}
				cb ? cb(err, data) : null;
			});
		},
		getUserLeft: function (store, [cb]) {
			store.dispatch('getUserLeftUp', [function (err) {
				if (err) {
					cb ? cb(err, null) : null;
					return
				}
				store.dispatch('getUserLeftDown', [function (err, data) {
					if (err) {
						cb ? cb(err, null) : null;
						return
					}
					cb ? cb(err, data) : null;
				}])
			}])
		},
		getUserLeftUp: function (store, [cb]) {
			if (store.state.isGetUserLeftUp) {
				cb ? cb(null, null) : null;
				return;
			}
			let data = {
				uid: store.state.user.uid,
				openid: store.state.user.openid,
				pid: "",
				type: 1
			}
			if (store.state.user.suid) {
				delete data.uid;
				data.suid = store.state.user.suid
			}
			if (store.state.router.appid == "QH360V5SRT" || store.state.router.appid == "ToToLink") {
				data.pid = store.state.localPid;
			}
			Req.router.server.userInfo(data, function (err, data) {
				// test
				// data.data.left = 10000;
				if (!err && data.data) {

					if (data.data.left > 0) {
						store.state.isPayUp = true;
						store.state.upPay.left = data.data.left;
					} else {
						store.state.isPayUp = false;
						store.state.upPay.left = 0;
					}

				}
				cb ? cb(err, data) : null;
			});
		},
		getUserLeftDown: function (store, [cb]) {
			if (store.state.isGetUserLeftDown) {
				cb ? cb(null, null) : null;
				return;
			}
			let data = {
				uid: store.state.user.uid,
				openid: store.state.user.openid,
				pid: "",
				type: 2
			}
			if (store.state.user.suid) {
				delete data.uid;
				data.suid = store.state.user.suid
			}
			if (store.state.router.appid == "QH360V5SRT" || store.state.router.appid == "ToToLink") {
				data.pid = store.state.localPid;
			}
			Req.router.server.userInfo(data, function (err, data) {
				// test
				// data.data.left = 10000;
				// data = {
				// 	"code": 3505,
				// 	"msg": "V未查到目标速率",
				// 	"data": {
				// 		"left": 5628202,
				// 		"basic_down": 512000,
				// 		"basic_up": 51200,
				// 		"target_down": 0,
				// 		"target_up": 0,
				// 		"account": "DCDCD5EF8E7889E0642F5ABB4F902C12915002455D467D73",
				// 		"addr": "120.85.107.117:4100",
				// 		"isp": "联通",
				// 		"city": "",
				// 		"province": "广东",
				// 		"country": "中国"
				// 	}
				// }
				if (!err && data.data) {

					if (data.data.left > 0) {
						store.state.isPayDown = true;
						store.state.downPay.left = data.data.left;
					} else {
						store.state.isPayDown = false;
						store.state.downPay.left = 0;
					}

				}
				cb ? cb(err, data) : null;
			});
		},
		getUserInfo: function (store, [cb]) {
			let info = {
				left_up: 0,
				left_down: 0,
				basic_up: 0,
				basic_down: 0,
				target_up: 0,
				target_down: 0
			}
			store.dispatch('getUserInfoUp', [function (err, data) {
				if (err) {
					cb ? cb(err, null) : null;
					return
				}
				if (data.data) {
					info.left_up = data.data.left;
					info.basic_up = data.data.basic_up;
					info.target_up = data.data.target_up;
				}

				store.dispatch('getUserInfoDown', [function (err, data) {
					if (err) {
						cb ? cb(err, null) : null;
						return
					}
					if (data.data) {
						info.left_down = data.data.left;
						info.basic_down = data.data.basic_down;
						info.target_down = data.data.target_down;
					}
					data.code = 0;
					data.data = info;

					cb ? cb(err, data) : null;
				}])
			}])
		},
		getUserInfoUp: function (store, [cb]) {
			let data = {
				uid: store.state.user.uid,
				openid: store.state.user.openid,
				pid: "",
				type: 1
			}
			if (store.state.user.suid) {
				delete data.uid;
				data.suid = store.state.user.suid
			}
			if (store.state.router.appid == "QH360V5SRT" || store.state.router.appid == "ToToLink") {
				data.pid = store.state.localPid;
			}
			Req.router.server.userInfo(data, function (err, data) {
				// test
				// data = {
				// 	"code": 0,
				// 	"msg": "no-up-mould",
				// 	"data": {
				// 		"left": 1024,
				// 		"basic_down": 1024,
				// 		"basic_up": 1024,
				// 		"target_down": 10240,
				// 		"target_up": 10240,
				// 		"isp": "电信",
				// 		"city": "",
				// 		"province": "广东省",
				// 		"country": "中国"
				// 	}
				// }
				// console.log(data);

				// data = {
				// 	"code": 0,
				// 	"msg": "ok",
				// 	"data": {
				// 		"left": 0,
				// 		"basic_down": 204800,
				// 		"basic_up": 30720,
				// 		"target_down": 204800,
				// 		"target_up": 51200,
				// 		"account": "F06A12292C6E94198C6C6A93361D6EB0",
				// 		"isp": "联通",
				// 		"city": "",
				// 		"province": "北京",
				// 		"country": "中国"
				// 	}
				// };

				// console.log(data);

				store.dispatch('sendUserlog', ["check_up", JSON.stringify(data)]);

				if (!err && data.data) {

					store.state.queryUpCode = data.code;

					if (!store.state.bindAccount) {
						store.state.province = data.data.province ? data.data.province : "";
						store.state.isp = data.data.isp ? data.data.isp : "";
					}

					store.state.isCheckSupportUp = true;

					if (data.data.left > 0) {
						store.state.isPayUp = true;
						store.state.upPay.left = data.data.left;
					} else {
						store.state.isPayUp = false;
						store.state.upPay.left = 0;
					}

					if (data.code == 0) {

						store.state.nowUpSpeed = data.data.basic_up / 1024;
						store.state.toUpSpeed = data.data.target_up / 1024;

						if (data.data.target_up > data.data.basic_up) {
							store.state.isSupportUp = true;
						}

					}

					if (store.state.isSupportUp) {
						store.dispatch('sendUserlog', ["check_up_success", JSON.stringify(data)]);
					}
				}
				cb ? cb(err, data) : null;
			});
		},
		getUserInfoDown: function (store, [cb]) {
			let data = {
				uid: store.state.user.uid,
				openid: store.state.user.openid,
				pid: "",
				type: 2
			}
			if (store.state.user.suid) {
				delete data.uid;
				data.suid = store.state.user.suid
			}
			if (store.state.router.appid == "QH360V5SRT" || store.state.router.appid == "ToToLink") {
				data.pid = store.state.localPid;
			}
			Req.router.server.userInfo(data, function (err, data) {
				// test
				// data = {
				// 	"code": 0,
				// 	"msg": "no-up-mould",
				// 	"data": {
				// 		"left": 0,
				// 		"basic_down": 1024,
				// 		"basic_up": 1024,
				// 		"target_down": 102400,
				// 		"target_up": 10240,
				// 		"isp": "电信",
				// 		"city": "",
				// 		"province": "广东省",
				// 		"country": "中国"
				// 	}
				// }
				// console.log(data);

				// data = {
				// 	"code": 0,
				// 	"msg": "ok",
				// 	"data": {
				// 		"left": 0,
				// 		"basic_down": 204800,
				// 		"basic_up": 30720,
				// 		"target_down": 307200,
				// 		"target_up": 0,
				// 		"account": "F06A12292C6E94198C6C6A93361D6EB0",
				// 		"isp": "联通",
				// 		"city": "",
				// 		"province": "北京",
				// 		"country": "中国"
				// 	}
				// };

				// data = {
				// 	"code": 2103,
				// 	"msg": "电信线路暂不支持",
				// 	"data": {
				// 		"left": 0,
				// 		"basic_down": 0,
				// 		"basic_up": 0,
				// 		"target_down": 0,
				// 		"target_up": 0,
				// 		"account": "",
				// 		"isp": "电信",
				// 		"city": "",
				// 		"province": "福建",
				// 		"country": "中国"
				// 	}
				// }

				// data = {
				// 	"code": 3505,
				// 	"msg": "V未查到目标速率",
				// 	"data": {
				// 		"left": 5628202,
				// 		"basic_down": 512000,
				// 		"basic_up": 51200,
				// 		"target_down": 0,
				// 		"target_up": 0,
				// 		"account": "DCDCD5EF8E7889E0642F5ABB4F902C12915002455D467D73",
				// 		"addr": "120.85.107.117:4100",
				// 		"isp": "联通",
				// 		"city": "",
				// 		"province": "广东",
				// 		"country": "中国"
				// 	}
				// }


				store.dispatch('sendUserlog', ["check_down", JSON.stringify(data)]);

				if (!err && data.data) {

					store.state.queryDownCode = data.code;

					if (!store.state.bindAccount) {
						store.state.province = data.data.province ? data.data.province : "";
						store.state.isp = data.data.isp ? data.data.isp : "";
					}

					store.state.isCheckSupportDown = true;

					if (data.data.left > 0) {
						store.state.isPayDown = true;
						store.state.downPay.left = data.data.left;
					} else {
						store.state.isPayDown = false;
						store.state.downPay.left = 0;
					}

					if (data.code == 0) {

						store.state.nowDownSpeed = data.data.basic_down / 1024;
						store.state.toDownSpeed = data.data.target_down / 1024;

						if (data.data.target_down > data.data.basic_down) {
							store.state.isSupportDown = true;
						}

					}

					if (store.state.isSupportDown) {
						store.dispatch('sendUserlog', ["check_down_success", JSON.stringify(data)]);
					}
				}
				cb ? cb(err, data) : null;
			});
		},

		getGoodsList: function (store, [type, cb]) {
			let data = {
				uid: store.state.user.uid,
				openid: store.state.user.openid,
				pid: store.state.bindPid,
				sid: 104,
				category: type
			}
			if (store.state.user.suid) {
				delete data.uid;
				data.suid = store.state.user.suid
			}
			Req.router.server.goods(data, function (err, data) {
				if (!err && data.data) {
					let goods = [];

					data.data.sort(function (a, b) {
						return a.gsellprice - b.gsellprice;
					})

					// console.log(data.data);
					let dataArray = [];
					for (let index = 0; index < 2; index++) {
						const element = data.data[index];
						dataArray.push(element);
					}

					data.data = dataArray;

					if (type == 1) {
						for (let index = 0; index < data.data.length; index++) {
							const element = data.data[index];
							if (element.gstatus == 1) {
								goods.push(element);
							}
						}
						store.state.goodsUp = goods;
					} else {
						for (let index = 0; index < data.data.length; index++) {
							const element = data.data[index];
							if (element.gstatus == 1) {
								goods.push(element);
							}
						}
						store.state.goodsDown = goods;
					}
					store.state.goods = goods;
				}

				cb ? cb(err, data) : null;
			});
		},
		getPaySign: function (store, [gid, cb]) {
			let data = {
				pid: store.state.bindPid,
				uid: store.state.user.uid,
				// openid: store.state.user.openid,
				appid: store.state.app.appid,
				"trade_type": "NATIVE",
				dial: store.state.localAccount,
				ref_uid: store.state.router.refuid
			}
			if (store.state.user.suid) {
				delete data.uid;
				data.suid = store.state.user.suid;
			}
			data.gid = gid;
			Req.router.pay.sign(data, cb);
		},
		getPayCheck: function (store, [tid, cb]) {
			let data = {
				pid: store.state.bindPid,
				uid: store.state.user.uid,
				openid: store.state.user.openid,
				appid: store.state.app.appid
			}
			if (store.state.user.suid) {
				delete data.uid;
				data.suid = store.state.user.suid
			}
			data.out_trade_no = tid;
			Req.router.pay.check(data, cb);
		},
		getUserDev: function (store, [cb]) {
			let data = {
				uid: store.state.user.uid,
				openid: store.state.user.openid
			}
			if (store.state.user.suid) {
				delete data.uid;
				data.suid = store.state.user.suid
			}
			// console.log("getUserDev");
			Req.router.server.user.dev(data, cb);
		},
		addUserDev: function (store, [pid, cb]) {
			let data = {
				uid: store.state.user.uid + "",
				openid: store.state.user.openid,
				add: [pid]
			}
			if (store.state.user.suid) {
				delete data.uid;
				data.suid = store.state.user.suid
			}
			Req.router.server.user.updateDev(data, cb);
		},
		getGiftInfo: function (store, [cb]) {
			let data = {
				uid: store.state.user.uid,
				openid: store.state.user.openid,
				gift_id: 1001,
				query: true
			}
			if (store.state.user.suid) {
				delete data.uid;
				data.suid = store.state.user.suid
			}
			Req.router.server.gift(data, cb);
		},
		getGift: function (store, [cb]) {
			let data = {
				uid: store.state.user.uid,
				openid: store.state.user.openid,
				gift_id: 1001,
				query: false
			}
			if (store.state.user.suid) {
				delete data.uid;
				data.suid = store.state.user.suid
			}
			Req.router.server.gift(data, cb);
		},
		getLogin: function (store, [code, tuid, buid, appid, chanid, refuid, cb]) {
			let data = {
				code: code,
				tuid: tuid,
				buid: buid,
				appid: appid,
				chanid: chanid,
				ref_uid: refuid
			}
			Req.router.server.login(data, function (err, data) {
				if (data.rtn == 0) {
					let uid = data.data.uid;
					let openid = data.data.openid;
					let nickname = data.data.nick;
					let headimg = data.data.headimgurl;
					localStorage.setItem("kd2-uid", uid);
					localStorage.setItem("kd2-openid", openid);
					localStorage.setItem("kd2-nickname", nickname);
					localStorage.setItem("kd2-headimg", headimg);
					store.state.user.uid = uid;
					store.state.user.openid = openid;
					store.state.user.nickname = nickname;
					store.state.user.headimg = headimg;
					store.state.isLogin = true;
					store.dispatch('sendUserlog', ["login", "", function (err, data) {
						window.location.replace(window.location.href.split("?")[0]);
					}]);
				}
				cb ? cb(err, data) : null;
			});
		},
		goLogin: function (store, [cb]) {
			store.state.isShowLogin = true;
			// window.location.href = store.state.loginUrl;
			cb ? cb() : "";
		},
		getLogout: function (store, [cb]) {
			localStorage.setItem("kd2-uid", "");
			localStorage.setItem("kd2-openid", "");
			localStorage.setItem("kd2-nickname", "");
			localStorage.setItem("kd2-headimg", "");
			window.location.reload();
			cb ? cb() : "";
		}
	},
	modules: {}
})